import {CSSProperties, FC} from 'react';


export interface IIconArrowUpProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconArrowUp: FC<IIconArrowUpProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="m12 10.555-6.223 6.223L4 15l8-8 8 8-1.777 1.777L12 10.555Z" clipRule="evenodd" />
        </svg>
    );
};
